module.exports = __webpack_public_path__ + "static/media/icon-cancel.c5ab6a82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-cancel.svg
// module id = 1243
// module chunks = 19